import { palette as importedPalette } from '../../../styles/material-ui/palette'

import { SORTING_DIRECTIONS, FILTER_SELECT_TYPES } from './table.constants'

/** @type {Styles} */

export const styles = {
  row: {
    borderTopColor: (theme) =>
      theme?.palette?.custom?.table?.main || importedPalette.custom.table.main,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderBottomColor: (theme) =>
      theme?.palette?.custom?.table?.main || importedPalette.custom.table.main,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
  },
  smallLoading: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'scale(0.5)', // Smaller scale to ensure it fits within 32px
    transformOrigin: 'center',
    '& .MuiCircularProgress-root': {
      width: '32px !important',
      height: '32px !important',
    },
  },
  toolbarDivider: {
    height: 32,
    width: 2,
    borderColor: 'gray.12',
    marginLeft: 1.5,
    marginRight: 1.5,
    display: { xs: 'none', md: 'block' },
  },
  wrapperFilterMobile: {
    height: '100%',
    paddingTop: 1,
    backgroundColor: { xs: importedPalette.gray[3], lg: 'transparent' },
  },
  rowCell: {
    border: 0,
    overflowWrap: 'break-word',
    maxWidth: 250,
  },
  dragHandleCell: {
    cursor: 'grab',
    width: 32,
    maxWidth: 32,
    paddingX: 0.5,
  },
  dragHandleIcon: {
    width: 20,
    height: 20,
    color: 'gray.40',
  },
  iconButton: {
    padding: 0,
    marginLeft: { xs: 2, md: 0 },
    cursor: 'default',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '.MuiSvgIcon-root': { color: 'gray.56', fontSize: 24, marginRight: 1.5 },
    '.Mui-disabled': {
      '.MuiSvgIcon-root': {
        color: 'gray.16',
      },
    },
  },
  table: {
    borderWidth: 0,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  optionsCheckbox: { border: 'none', marginTop: 0, padding: 0, height: '100%' },
  optionsRadio: {
    mt: -3,
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    '.MuiFormControlLabel-root': {
      color: 'unset',
      margin: 0,
      paddingX: 0,
      flex: '1 1 auto',
      minWidth: 0,
    },
  },
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 2.5,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    justifyContent: {
      sm: 'space-between',
    },
    alignItems: {
      xs: 'flex-start',
      md: 'center',
    },
  },

  titleDescStyles: { display: 'flex', flexDirection: 'column' },
  title: {
    color: 'gray.100',
    typography: 'header1',
    lineHeight: 1.4,
  },
  description: {
    color: 'gray.64',
    typography: 'medium',
  },
  flex: {
    display: 'flex',
  },
  filtersRoot: {
    display: 'flex',
    width: '100%',
    backgroundColor: 'info.lightest',
    paddingTop: { xs: 0, md: 0 },
  },
  filtersTopBorder: {
    border: '1px solid',
    borderBottom: 0,
    borderColor: 'divider',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    '& > div > div:first-child': {
      borderLeft: 0,
    },
    '& > div > div:last-child': {
      borderRight: 0,
    },
  },
  columnsFilters: {
    backgroundColor: 'gray.0',
    display: 'flex',
    alignItems: { xs: 'self-start', md: 'center' },
    flexDirection: { xs: 'column', md: 'row' },
    width: { xs: 'unset', md: '100%' },
    border: 0,
  },
  flexCenter: { display: 'flex', alignItems: 'center' },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'self-start', md: 'center' },
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    maxWidth: { xs: 'calc(100% - 60px)', md: '180px' },
  },
  clearFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    width: 154,
    height: 56,
    padding: 2,
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: 'divider',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderRightColor: 'divider',
    borderRadius: 0,
  },
  filterLabelMobileContainer: {
    display: 'flex',
    alignItems: 'center',
    width: { xs: 66 },
    height: 56,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'divider',
    borderLeft: 'none',
    borderRightWidth: 0,
    justifyContent: { xs: 'center', md: 'flex-start' },
    padding: { xs: 0, md: 2.5 },
    borderTopLeftRadius: 0,
  },
  filterLabelDesktopContainer: {
    display: 'flex',
    alignItems: 'center',
    width: { xs: 66 },
    height: 56,
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: 'divider',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderRightColor: 'divider',
    justifyContent: { xs: 'center', md: 'flex-start' },
    padding: { xs: 0, md: 2.5 },
    borderTopLeftRadius: { xs: 8, md: 0 },
  },
  clearFilterButton: {
    padding: 0,
    '.MuiButton-startIcon': {
      marginRight: 2,
      marginLeft: 0,
    },
  },
  filterIcon: { color: 'gray.56', fontSize: 24, marginRight: 1.5 },
  filtersLabel: { color: 'gray.64', display: { xs: 'none', md: 'block' } },
  secondaryActionContainer: {
    marginRight: 2.5,
    marginBottom: { xs: 1, sm: 0.5, md: 0 },
    width: { xs: '100%', sm: 'auto' },
  },
  otherActionParentContainer: {
    display: 'flex',
  },
  otherActionContainer: { marginRight: 2.5, width: { xs: '100%', sm: 'auto' } },
  secondaryAction: {
    borderWidth: 1,
    borderColor: 'gray.12',
    borderStyle: 'solid',
    width: { xs: '100%', sm: 'auto' },
    marginBottom: { xs: 1, sm: 0.5, md: 0 },
  },

  paginationContainer: {
    display: { xs: 'none', sm: 'flex' },
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
    alignItems: {
      xs: 'flex-start',
      sm: 'center',
    },
    justifyContent: {
      xs: 'flex-start',
      sm: 'center',
      md: 'flex-end',
    },
  },
  rowsPerPageLabel: {
    width: 'max-content',
    marginRight: { xs: 2, sm: 0 },
    color: 'gray.64',
    display: { xs: 'none', sm: 'block' },
  },
  rowsPerPageContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pageQuantityLabel: {
    marginLeft: { xs: 0, sm: 1 },
    color: 'gray.64',
    whiteSpace: 'nowrap',
  },
  pageQuantityContainer: { display: 'flex', gap: 1 },
  // Pagination fade-in animation - opacity controlled dynamically based on data load state
  pageQuantityFadeIn: {
    opacity: 1,
    transition: 'opacity 300ms ease-in-out',
  },
  pageQuantityHidden: {
    opacity: 0,
  },
  hidePaginationUI: { display: 'none' },
  paginationIconsContainer: { display: 'flex', marginLeft: 1 },
  primaryActionContainer: {
    marginBottom: { xs: 0.5, md: 0 },
  },
  primaryAction: {
    borderWidth: 1,
    borderColor: 'gray.12',
    borderStyle: 'solid',
    width: { xs: '100%', md: 'max-content' },
    marginTop: { xs: 0.5, sm: 0 },
    marginBottom: { xs: 0.5, md: 0 },
  },
  wrapLoading: { minWidth: 159 },
  paginationSelectContainer: {
    marginLeft: {
      xs: 0,
      sm: 1,
    },
  },
  search: {
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',

      'div > .MuiOutlinedInput-notchedOutline': {
        borderColor: 'divider',
        borderRightStyle: { xs: 'none', sm: 'solid' },
        borderLeftStyle: { xs: 'none', sm: 'solid' },

        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTopRightRadius: 8,
      },
    },
    onlySearch: {
      '.MuiOutlinedInput-root': {
        borderTopLeftRadius: 8,
      },
    },
  },
  paginationSelect: {
    root: {
      '&:hover': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'gray.56',
        },
      },
      '&.MuiOutlinedInput-root': {
        paddingRight: 1,
      },
      '.MuiOutlinedInput-notchedOutline': {
        borderRadius: 5,
        borderColor: 'gray.12',
      },
      '.MuiSelect-select': {
        paddingY: 0.75,
        paddingLeft: 2,
        paddingRight: 3,
        typography: 'header4',
        color: 'gray.56',
      },
      '.MuiSelect-icon': {
        marginLeft: 1,
        marginRight: 1,
        color: 'gray.56',
      },
      '.MuiMenuItem-root': {
        ':hover': {
          backgroundColor: 'primary.lightest',
        },
      },
      '.Mui-selected': {
        backgroundColor: 'primary.lightest',
        color: 'primary.main',
      },
      '.MuiPaper-root': {
        backgroundColor: 'gray.0',
        color: 'gray.80',
      },
    },
  },
  filterSelect: {
    renderValue: {
      paddingRight: 6,
      maxWidth: { xs: '100%', md: '80%' },
    },
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'space-between',
      alignItems: { xs: 'self-start', md: 'center' },
      borderRadius: 0,
      marginBottom: { xs: 2, md: 0 },
      borderRightColor: 'gray.12',
      borderRightStyle: 'solid',
      borderRightWidth: { xs: 0, md: 1 },
    },
    desktopSelect: {
      '.MuiList-root': {
        backgroundColor: 'gray.0',
      },
      '&:hover': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'gray.16',
        },
      },
      '&.MuiOutlinedInput-root': {
        minWidth: {
          xs: 180,
          md: 0,
          lg: 180,
        },
        height: 56,
        paddingRight: 1,
        typography: 'header4',
        color: 'gray.80',
        borderRadius: { xs: 1, md: 0 },
        width: '100%',
      },
      '.MuiOutlinedInput-notchedOutline': {
        border: 0,
      },
      '.MuiSelect-select': {
        paddingY: 2,
        paddingLeft: 2,
        paddingRight: 3,
      },
      '.Mui-disabled': {
        WebkitTextFillColor: `${importedPalette.gray[56]}`,
      },
      '.MuiSelect-icon': {
        marginLeft: 1,
        marginRight: 1,
      },
      '.MuiMenuItem-root': {
        typography: 'large',
        paddingY: 1.5,
        color: 'gray.80',
        '&:hover': {
          backgroundColor: 'primary.lightest',
        },
      },
      '.MuiSvgIcon-root': {
        color: 'gray.56',
      },
      '.Mui-selected': {
        backgroundColor: 'primary.lightest',
      },
    },
    mobileSelect: {
      '.MuiList-root': {
        backgroundColor: 'gray.0',
      },
      '&:hover': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'gray.16',
        },
      },
      '&.MuiOutlinedInput-root': {
        minWidth: 180,
        height: 56,
        paddingRight: 1,
        typography: 'header4',
        color: 'gray.80',
        borderRadius: { xs: 1, md: 0 },
        width: '100%',
      },
      '.MuiOutlinedInput-notchedOutline': {
        borderStyle: 'solid',
        borderColor: 'divider',
        borderWidth: 1,
      },
      '.MuiSelect-select': {
        paddingY: 2,
        paddingLeft: 2,
        paddingRight: 3,
      },
      '.MuiSelect-icon': {
        marginLeft: 1,
        marginRight: 1,
      },
      '.MuiMenuItem-root': {
        typography: 'large',
        paddingY: 1.5,
        color: 'gray.80',
        '&:hover': {
          backgroundColor: 'primary.lightest',
        },
      },
      '.MuiSvgIcon-root': {
        color: 'primary.main',
      },
      '.Mui-selected': {
        backgroundColor: 'primary.lightest',
      },
    },
    clearButton: {
      '.MuiSvgIcon-root': {
        color: 'primary.main',
      },
      zIndex: 5,
    },
    clearButtonMobile: {
      '.MuiSvgIcon-root': {
        color: 'primary.main',
        marginTop: '10px',
      },
      zIndex: 5,
      position: 'absolute',
      right: 50,
    },
    clearButtonContainer: { position: 'absolute', right: 40 },
    selectedPlaceholder: { color: 'gray.56' },
    value: {
      color: 'primary.main',
    },
    mobileValue: {
      color: 'primary.main',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    placeholder: {
      fontWeight: { xs: 400, md: 'unset' },
    },
  },
  head: { backgroundColor: 'gray.3' },
  tableContainer: {
    height: '100%',
    overflow: 'overlay',
    scrollbarColor: 'gray.3',
    '::-webkit-scrollbar': {
      width: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'divider',
    },
  },
  tableHeader: {
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: -1,
      zIndex: 10,
      backgroundColor: 'gray.3',
      borderBottomColor: 'divider',
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
    },
  },
  customTableTabletView: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    maxHeight: 'calc(100vh - 200px)',
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  tabletPagination: { margin: 'auto', marginTop: 1.5 },
  paperContainer: {
    width: '100%',
    overflow: 'hidden',
    backgroundColor: 'inherit',
    boxShadow: 'none',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderTop: 1,
    borderTopColor: 'divider',
    borderLeft: 0,
    borderRight: 0,
    border: '1px solid',
    borderColor: 'divider',
  },
  header: { color: 'gray.80' },
  rowLabel: { color: 'gray.80', typography: 'medium' },
  globalClientSideFilter: {
    height: 56,
    width: '100%',
    backgroundColor: 'gray.0',
    marginTop: 2, // 16px spacing above search bar
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 9.25,
    paddingBottom: 10.5,
    borderWidth: 1,
    borderColor: 'gray.8',
    borderStyle: 'solid',
    height: '100%',
  },
  emptyIcon: { color: 'gray.16', fontSize: 40 },
  copyIcon: {
    verticalAlign: 'bottom',
    fontSize: 20,
    marginLeft: 1,
    color: 'gray.64',
    cursor: 'pointer',
    '&:hover': {
      color: 'primary.main',
    },
  },
  brandNameContainer: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'gray.16',
      '& .MuiTypography-body1': {
        color: 'primary.main',
      },
    },
  },
  headerButton: {
    ':hover, :focus': {
      '.MuiTypography-root': {
        color: 'gray.100',
      },
    },
    '.MuiTypography-root': {
      color: 'gray.80',
    },
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    cursor: 'pointer',
  },
  helperText: {
    display: 'flex',
    backgroundColor: 'gray.3',
    gap: 1.25,
    borderRadius: 0.5,
    paddingRight: 2.5,
    paddingLeft: 1.5,
    paddingY: 1.5,
    marginY: 2,
    width: '100%',
  },
  filterMobile: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'gray.8',
  },
  iconEdit: {
    width: 32,
    height: 32,
    color: (theme) => theme?.palette?.gray?.[64] || importedPalette.gray[64],
  },
  tableForm: ({ palette } = {}) => ({
    width: '100%',
    flex: 1,
    borderRightColor: palette?.gray?.[16] || importedPalette.gray[16],
    borderRightStyle: 'solid',
    borderRightWidth: 1,
  }),
  tableFormMobile: {
    width: '100%',
    padding: 0,
    margin: 0,
  },
  componentFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    height: 56, // Match standard filter row height
    paddingY: '20px',
    paddingX: '16px',
    borderRightColor: 'gray.16',
    borderRightStyle: 'solid',
    borderRightWidth: 1,
  },
  mobileTabletCustomActionsContainer: {
    flexDirection: { xs: 'row', sm: 'row-reverse', md: 'row' },
    gap: { xs: 0, sm: 2, md: 0 },
    my: { xs: 0, sm: 2, md: 0 },
  },
}

export const handleStylesWithProps = ({
  opacity,
  canGoBack,
  canGoForward,
  sorting,
  column,
  filterSelectType,
  isLoading,
  disabled,
  toolbarWithBorder,
}) => ({
  row: {
    opacity,
  },
  goBackIcon: {
    color: canGoBack && !isLoading ? 'gray.56' : 'gray.16',
    cursor: canGoBack && !isLoading ? 'pointer' : 'unset',
    marginRight: {
      sm: 2,
      md: 0,
    },
  },
  goForwardIcon: {
    color: canGoForward && !isLoading ? 'gray.56' : 'gray.16',
    cursor: canGoForward && !isLoading ? 'pointer' : 'unset',
  },
  filterSelect: {
    select: {
      minWidth: filterSelectType === FILTER_SELECT_TYPES.date ? 300 : 'unset',
      '.MuiSvgIcon-root': {
        color: disabled ? 'gray.16' : 'gray.64',
      },
      placeholder: {
        color: disabled ? 'gray.40' : { xs: 'gray.56', md: 'gray.80' },
      },
    },
    headerButtonAsc: {
      opacity:
        SORTING_DIRECTIONS.desc !== sorting?.direction || column.serverSideKey !== sorting?.field
          ? 1
          : 0.35,
      marginBottom: -1.5,
      color: 'gray.56',
      fontSize: 24,
    },
    headerButtonDesc: {
      opacity:
        SORTING_DIRECTIONS.asc !== sorting?.direction || column.serverSideKey !== sorting?.field
          ? 1
          : 0.35,
      fontSize: 24,
      color: 'gray.56',
    },
  },
  headerContainer: {
    marginBottom: {
      xs: toolbarWithBorder ? 0 : 0.5,
    },
  },
})

/** @type {Styles} */
export const tabletStyles = {
  tabletFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    backgroundColor: 'gray.0',
    padding: 0,
    border: '1px solid',
    borderColor: 'gray.16',
    borderBottom: 'none',
    height: 56,
  },
  buttonWrapper: {
    width: '100%',
    gap: 1,
    marginTop: 2,
  },
  verticalDivider: {
    alignSelf: 'stretch',
    backgroundColor: 'gray.16',
    width: '1px',
    color: 'gray.16',
    borderColor: 'gray.16',
  },
  customIconButton: {
    paddingTop: { xs: 5.5, sm: 0, md: 1 },
    marginLeft: { xs: 1, sm: 0, md: 1 },
  },
  iconButton: {
    padding: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'gray.12',
    width: 40,
    height: 40,
  },
  filterIcon: {
    color: 'gray.56',
    fontSize: 24,
  },
  searchIcon: {
    marginRight: 1,
    color: 'gray.56',
  },
  paginationContainer: {
    padding: 2,
    marginTop: 0.5,
  },
  searchContainer: {
    width: '100%',
    '.MuiOutlinedInput-root': {
      width: '100%',
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
    '.MuiSvgIcon-root': {
      fontSize: 24,
      color: 'primary.main',
    },
  },
  searchInput: {
    flexGrow: 1,
    padding: 1,
    border: 'none',
    borderRadius: 4,
  },
}
